import { emptyStateAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const emptyStateSlotRecipe = defineSlotRecipe({
  slots: emptyStateAnatomy.keys(),
  className: 'empty-state',
  base: {
    root: {
      border: '1px solid',
      borderColor: 'border/minimal',
      borderRadius: '4',
      padding: ['32', '48'],
    },
    content: {
      maxWidth: rem(480),
      marginInline: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    indicator: {
      color: 'icon/tertiary',
    },
    title: {
      textStyle: 'heading/h4',
      color: 'text/secondary',
      marginBlock: '8',
    },
    description: {
      textStyle: 'body/md/regular',
      color: 'text/secondary',
      '&:has(+ *)': {
        marginBlockEnd: '24',
      },
    },
  },

  variants: {
    colorVariant: {
      white: {
        root: {
          backgroundColor: 'background/primary',
        },
      },
      gray: {
        root: {
          backgroundColor: 'background/secondary',
        },
      },
    },
  },

  defaultVariants: {
    colorVariant: 'gray',
  },
});

export default emptyStateSlotRecipe;
